import React, { FunctionComponent, useState } from "react";
import { Aside, ListActionButtonProps, Stack } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { EncodeSpecificationType } from "../../context/EncodeSpecificationItem";
import { EncodeSpecificationListingItem } from "../EncodeSpecificationListingItem";
import { EditEncodeSpecificationMpeg1Form } from "../forms/edit/EditEncodeSpecificationMpeg1Form";
import { EditEncodeSpecificationMpeg4Form } from "../forms/edit/EditEncodeSpecificationMpeg4Form";

export const EditEncodeSpecificationButton: FunctionComponent<ListActionButtonProps<EncodeSpecificationListingItem>> = (
    props: ListActionButtonProps<EncodeSpecificationListingItem>
) => {
    const { disabled, item } = props;
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const isButtonDisabled = disabled;

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    const editEncodeSpecificationForm = () => {
        switch (item.type) {
            case EncodeSpecificationType.MPEG_1: {
                return (
                    <EditEncodeSpecificationMpeg1Form onCancel={closeAside} onSubmit={handleFormSubmit} item={item} />
                );
            }
            case EncodeSpecificationType.MPEG_4: {
                return (
                    <EditEncodeSpecificationMpeg4Form onCancel={closeAside} onSubmit={handleFormSubmit} item={item} />
                );
            }
            default:
                throw new Error("Incorrect encode specification type.");
        }
    };

    return (
        <>
            <EditListButton onClick={openAside} disabled={isButtonDisabled} />
            <Aside type={"form"} isOpen={isAsideOpen} headerText="Edit Encode Specification" onDismiss={closeAside}>
                <Stack>{editEncodeSpecificationForm()}</Stack>
            </Aside>
        </>
    );
};
